// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  twonaBaseUrl: "https://pre-api.twonas.com",
  appBasePath: "/app",
  loginBasePath: "/login",
  services: {
    pusher: {
      key: "ddbc5d1d18940fb3610f",
      cluster: "eu"
    },
    sentry: {
      enabled: true,
      dsn: "https://fd708f8813b948b8489a8c61206b4550@o113565.ingest.us.sentry.io/4507254312665088"
    }
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
